<template>
    <div>
        <el-form
            :inline="true"
            :model="search"
            class="demo-form-inline"
        >
            <el-form-item label="客户分类">
                <el-select
                    ref="selectReport"
                    v-model="search.typeName"
                    style="width:160px"
                    placeholder=""
                    filterable
                >
                    <el-option
                        :value="search.type"
                        :label="search.typeName"
                        style="
                            width: 160px;
                            height: 200px;
                            overflow: auto;
                            background-color: #fff;
                        "
                    >
                        <el-tree
                            ref="tree"
                            :data="all"
                            :props="defaultProps"
                            node-key="id"
                            default-expand-all
                            @node-click="handleNodeClick"
                        />
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客户名称">
                <el-input v-model="search.cname" placeholder="输入客户名称"  style="width:160px" @input="changeName"/>
            </el-form-item>
        </el-form>
        <div style="max-height: 450px; overflow: auto">
            <el-table
                ref="multipleTable"
                v-loading="listLoading"
                :data="list"
                border
                fit
                highlight-current-row
                @row-dblclick="selectRowDb"
                @row-click="selectRow"
            >
                <el-table-column width="35">
                    <template slot-scope="{ row }">
                        <el-radio v-model="radio" :label="row.id">{{
                            ""
                        }}</el-radio>
                    </template>
                </el-table-column>
                <el-table-column
                    v-for="(col, index) in cols"
                    :key="index"
                    align="left"
                    :label="col.label"
                    :width="col.width"
                >
                    <template slot-scope="{ row }">
                        <span>{{ row[col.prop] }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
             style="margin-top: 15px;text-align: right;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search.page"
            :page-sizes="[20, 50, 120, 250]"
            :page-size="search.limit"
            layout="total, sizes, prev, pager, next"
            :total="search.total"
            :pager-count="5"
        />
    </div>
</template>

<script>

export default {
    props: {},
    data() {
        return {
            search: {
                category: "",
                typeName: "",
                cname: "",
                page: 1,
                limit: 20,
                total: 0,
                state:this.$global.customerState?this.$global.customerState:'',
            },
            list: [],
            all: [],
            defaultProps: {
                children: "children",
                label: "label",
                id: "1",
            },
            cols: [
                // {
                //     prop: "cnumber",
                //     label: "编号",
                //     width: 70,
                // },
                {
                    prop: "category",
                    label: "分类",
                },
                {
                    prop: "cname",
                    label: "客户名称",
                },
                // {
                //     prop: "phone",
                //     label: "联系电话",
                // },
            ],
            radio: 0,
            listLoading: false,
        };
    },
    created() {
        this.getList();
        this.getType();
    },
    methods: {
        changeName(){
            this.getList();
        },
        handleSizeChange(val) {
          this.search.limit = val;
          this.getList();
        },
        handleCurrentChange(val) {
          this.search.page = val;
          this.getList();
        },
        async getList() {
            this.listLoading = true;
            this.$api.customerlistCustomer(this.search).then((res) => {
                this.list = res.data.data.map((item) => {
                    item.category = item.category.toString();
                    return item;
                });
                this.search.total = res.data.count;
            });
            this.listLoading = false;
        },
        getType() {
            this.$api.customergetCustomerClassify().then((res) => {
                this.all = [];
                var all = {};
                all.children = res.data.data;
                all.id = 0;
                all.label = "全部";
                all.parent = -1;
                this.all.push(all);
            });
        },
        selectRow(row) {
            this.radio = row.id;
        },
        selectRowDb(row){
            this.radio = row.id;
            this.checkCustomer();
        },
        handleNodeClick(node) {
            this.search.category = node.id;
            this.search.typeName = node.label;
            this.$refs.selectReport.blur();
            this.getList();
        },
        checkCustomer() {
            this.list.map((item) => {
                if (item.id === this.radio) {
                    this.$emit("close", item);
                }
            });
        },
    },
};
</script>
